export interface MarketingSignupResult {
  ok: boolean;
  status?: number;
}

export async function submitMarketingSignup(
  email: string,
  turnstileToken?: string,
): Promise<MarketingSignupResult> {
  try {
    const apiOrigin = import.meta.env.VITE_API_ORIGIN ?? "";
    const response = await fetch(`${apiOrigin}/marketing/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(turnstileToken ? { "x-turnstile-token": turnstileToken } : {}),
      },
      credentials: "omit",
      body: JSON.stringify({ email }),
    });
    return { ok: response.ok, status: response.status };
  } catch {
    return { ok: false };
  }
}
